import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { IEPS } from 'interfaces/EPS';
import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IPaginatedListResponse,
} from 'interfaces/requests';

import { get, MICROSERVICES } from 'api';
import endpoints from './endpoints';
import {
  IEPSListState,
  IEPSListRequestParams,
  IEPSListKeyValue,
  IEPSListRequestOptions,
} from './interfaces';

export const loadEpsListAction = createAsyncThunk<
  IEPSListState,
  IEPSListRequestParams | void,
  { rejectValue: IMyKnownError }
>('epsList/fetch', async (payload = undefined, { rejectWithValue }) => {
  try {
    const options = Object.assign(
      {},
      payload ? payload?.options : {},
    ) as IEPSListRequestOptions;
    if (payload && options) {
      delete payload?.options;
    }
    const result = await get<IPaginatedListResponse<IEPS>>(
      MICROSERVICES.STRATEGIES,
      {
        url: endpoints.epsList(),
        params: payload,
      },
    );
    const epsByKey = {} as IEPSListKeyValue;
    const eps = result.data.values.map(
      (item, index): IEPS => {
        if (options?.generateEPSByKey) {
          epsByKey[item._id] = {
            fantasyName: item.fantasyName,
            companyName: item.companyName,
          };
        }

        return {
          ...item,
          id: item._id,
          contact: item.contact.map((c) => ({
            ...c,
            id: index.toString(),
          })),
        };
      },
    );
    return {
      count: result.data.count,
      list: eps,
      epsByKey,
    } as IEPSListState;
  } catch (error) {
    console.error('error at load eps list', error);
    return rejectWithValue(error.message);
  }
});

const initialState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  list: [],
  epsByKey: {},
  count: 0,
} as IEPSListState;

const epsListSlice = createSlice({
  name: 'espList',
  initialState,
  reducers: {
    clearEpsList: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(loadEpsListAction.fulfilled, (state, action) => {
      state.count = action.payload.count;
      state.list = action.payload.list;
      state.epsByKey = action.payload.epsByKey;
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
    });
    builder.addCase(loadEpsListAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
    });
    builder.addCase(loadEpsListAction.rejected, (state) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
    });
  },
});

const { reducer, actions } = epsListSlice;
export const { clearEpsList } = actions;
export default reducer;
